"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _hooks = require("../../hooks");
var _useParseActiveFilterStrings = _interopRequireDefault(require("./useParseActiveFilterStrings"));
var _CustomPropertiesFilterForm = _interopRequireDefault(require("./CustomPropertiesFilterForm"));
var _customProperties = require("../../constants/customProperties");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomPropertiesFilter = _ref => {
  let {
    activeFilters: {
      customProperties: custPropFilters,
      ...restOfFilters
    },
    customPropertiesEndpoint,
    filterHandlers,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {}
  } = _ref;
  const [editingFilters, setEditingFilters] = (0, _react.useState)(false);
  const openEditModal = () => setEditingFilters(true);
  const closeEditModal = () => setEditingFilters(false);
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const {
    data: custprops,
    isLoading
  } = (0, _hooks.useCustomProperties)({
    endpoint: customPropertiesEndpoint,
    returnQueryObject: true,
    options: {
      sort: [{
        path: 'ctx'
      },
      // Group by ctx
      {
        path: 'retired'
      },
      // Place retired custprops at the end
      {
        path: 'weight'
      },
      // Within those groups, sort by weight first
      {
        path: 'label'
      } // Within those groups, sort by label
      ]
    }
  });

  const parsedFilterData = (0, _useParseActiveFilterStrings.default)(custPropFilters || [], passedIntlKey, passedIntlNS, labelOverrides);
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Accordion, {
      closedByDefault: true,
      header: _components.FilterAccordionHeader,
      id: "clickable-custprop-filter",
      label: kintIntl.formatKintMessage({
        id: 'customProperties',
        overrideValue: labelOverrides.customProperties
      }),
      separator: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Spinner, {})
    });
  }
  const handleSubmit = values => {
    const {
      filters = []
    } = values;
    const filterStrings = filters.filter(filter => filter.rules).map(filter => {
      const relevantCustomProperty = custprops?.filter(cp => cp.name === filter.customProperty)?.[0] ?? {};
      const filterByValueId = relevantCustomProperty?.type === _customProperties.MULTI_REFDATA_CLASS_NAME || relevantCustomProperty?.type === _customProperties.REFDATA_CLASS_NAME;
      return filter.rules.map(rule => `customProperties.${filter.customProperty}.value${filterByValueId ? '.id' : ''}${rule.operator}${rule.value ?? ''}`).join('||');
    });
    filterHandlers.state({
      ...restOfFilters,
      customProperties: filterStrings
    });
    setEditingFilters(false);
    return Promise.resolve();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Accordion, {
    closedByDefault: true,
    displayClearButton: (parsedFilterData?.numberOfFilters ?? 0) > 0,
    header: _components.FilterAccordionHeader,
    id: "clickable-custprop-filter",
    label: kintIntl.formatKintMessage({
      id: 'customProperties',
      overrideValue: labelOverrides.customProperties
    }),
    onClearFilter: () => filterHandlers.state({
      ...restOfFilters,
      customProperties: []
    }),
    separator: false,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Layout, {
      className: "padding-bottom-gutter",
      children: kintIntl.formatKintMessage({
        id: 'customProperty.filtersApplied',
        overrideValue: labelOverrides.filtersApplied
      }, {
        count: parsedFilterData?.numberOfFilters ?? 0
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertiesFilterForm.default, {
      customProperties: custprops,
      editingFilters: editingFilters,
      filters: parsedFilterData?.filters,
      handlers: {
        closeEditModal,
        openEditModal
      },
      labelOverrides: labelOverrides,
      onSubmit: handleSubmit
    })]
  });
};
CustomPropertiesFilter.propTypes = {
  activeFilters: _propTypes.default.object,
  customPropertiesEndpoint: _propTypes.default.string,
  filterHandlers: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object
};
var _default = exports.default = CustomPropertiesFilter;